import React from 'react';
import { IconSvgProps } from '@models/common';

const Burger: React.FC<IconSvgProps> = (props) => {
  const { size = 24, strokeWidth = 2, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M3 5H21'
        stroke='currentColor'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
      />
      <path
        d='M3 12H17'
        stroke='currentColor'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
      />
      <path
        d='M3 19H21'
        stroke='currentColor'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
      />
    </svg>
  );
};

export default Burger;
